exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(undefined);
// imports


// module
exports.push([module.id, ".Tour {\n  height: 100vh; }\n  .Tour-MockPages {\n    position: absolute;\n    top: 0;\n    bottom: 0;\n    left: 0;\n    right: 0;\n    pointer-events: none; }\n    .Tour-MockPages .Game {\n      -webkit-transition: all 0.4s;\n      -o-transition: all 0.4s;\n      transition: all 0.4s; }\n      .Tour-MockPages .Game.Hide {\n        opacity: 0; }\n  .Tour-Overlay {\n    position: fixed;\n    top: 0;\n    left: 0;\n    right: 0;\n    bottom: 0;\n    height: 100vh;\n    z-index: 15; }\n    .Tour-Overlay svg {\n      width: 100vw;\n      height: 100vh; }\n  .Tour #hole {\n    -webkit-transition: d 1s;\n    -o-transition: d 1s;\n    transition: d 1s; }\n", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader?{"importLoaders":1}!./node_modules/postcss-loader/lib?{"ident":"postcss","plugins":[null,null]}!./src/pages/Tour/Tour.css
// module id = ./node_modules/css-loader/index.js?{"importLoaders":1}!./node_modules/postcss-loader/lib/index.js?{"ident":"postcss","plugins":[null,null]}!./src/pages/Tour/Tour.css
// module chunks = 0